module.exports = __webpack_public_path__ + "img/hbzh_tsfx.937ad6f8.svg";